module.exports = __webpack_public_path__ + "static/media/20200417_141804_compress44.a3c8e714.jpg";